var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-list-item',{staticStyle:{"cursor":"pointer"},on:{"!click":function($event){return _vm.toggle($event)}}},[_c('span',[_vm._v(_vm._s(_vm.label))]),_c('f7-toggle',{staticStyle:{"pointer-events":"none"},attrs:{"checked":_vm.value}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }